import React from 'react'
import ReactDOM from 'react-dom'
import './index.css'
import './pure-css-select-style.css'
import App from './App'

ReactDOM.render(<App />, document.getElementById('root'))
